import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';

export const baseURI = 'catalogos/conceptos-de-ingresos/';

/**
 * GET Conceptos de Ingresos
 * @returns {Promise<Array<object>>}
 */
export const getConceptosDeIngresos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return {
      ...response.data,
      results: formatReceived(response.data.results),
    };
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Concepto de Ingresos
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConceptoDeIngresos = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Concepto de Ingresos
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConceptoDeIngresos = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Concepto de Ingresos
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConceptoDeIngresos = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Concepto de Ingresos
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConceptoDeIngresos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
